import { addEvent } from "../addEvent/addEvent";

export function popUp() {
  let popUpContainer = document.getElementById("popupbox-container");

  if (!popUpContainer) return;

  let closeButton = popUpContainer.getElementsByClassName(
    "popupbox__close-button"
  )[0];

  addEvent(closeButton, "click", (e) => {
    e.preventDefault();

    $.post("/popup", { akceptacja: 1 });

    setTimeout(() => {
      document.body.classList.add("popupbox-container--hide");
    }, 100);

    setTimeout(() => {
      document.body.classList.remove("popupbox-container--hide");
      popUpContainer.remove();
    }, 1000);
  });
}
